export const BEARER = 'Bearer'
export const APPLICATION_JSON = 'application/json'
export const ACCESS_TOKEN = 'access_token'
